import instantsearch from 'instantsearch.js';
import algoliasearch from "algoliasearch";
import {
	configure,
	infiniteHits,
	// pagination,
	searchBox,
	stats,
	// currentRefinements,
	// clearRefinements,
	refinementList,
	menuSelect,
	// sortBy
} from 'instantsearch.js/es/widgets';
import { connectHits } from 'instantsearch.js/es/connectors'
export class SiteSearch {

	constructor() {
	}


	init() {

		//URL has a search query. activate the search overlay
		if (window.location.search.indexOf(window.ALGOLIA_INDEX_PREFIX + 'fullsite') !== -1) {
			document.body.classList.add('search-active');
		}

		const searchTemplate = window.MEFA_SEARCH_RESULT_TEMPLATE;
		if (!searchTemplate) {
			console.error('Missing search template');
			return;
		}

		const customNoResults = connectHits(
			(renderOptions, isFirstRender) => {
				const { hits, widgetParams, results } = renderOptions;
				const { container, noResultsText } = widgetParams;
				if(!container) return;

				if (isFirstRender) {
					const noResultsElement = document.createElement('div');
					noResultsElement.className = 'container';
					container.appendChild(noResultsElement);
				}


				const noResultsElement = container.querySelector('.container');
				if (hits.length === 0) {
					noResultsElement.innerHTML = noResultsText;
					if (results && !results.query) {
						noResultsElement.style.display = 'none';
					}else{
						noResultsElement.style.display = 'block';

					}
				} else {
					noResultsElement.style.display = 'none';
				}
			}
		);

		const search = instantsearch({
			indexName: window.ALGOLIA_INDEX_PREFIX + 'fullsite',
			searchClient: algoliasearch(
				window.ALGOLIA_APP_ID,
				window.ALGOLIA_KEY
			),
			future: {
				preserveSharedStateOnUnmount: true
			},
			routing: true,
			searchFunction(helper) {
				if (helper.state.query) {
					helper.search();
					document.querySelector('#search-no-results-text').classList.remove("default");
				} else {
					document.querySelector('.search-drop__bottom-block').classList.add("no-results-found");
				}
			}
		});

		search.addWidgets([
			searchBox({
				container: "#site-search-form-holder",
				placeholder: "What can we help you find?",
				searchAsYouType: false,
				showReset: true,
				cssClasses: {
					submit: 'icon-search2',
					reset: 'icon-close2',
					hits: 'search-results-container',
					input: 'form-control'
				}
			}),
			configure({
				hitsPerPage: 12,
			}),
			stats({
				container: '#site-search-stats',
				templates: {
					text(data, { html }) {
						if (data.hasManyResults || data.hasOneResult) {
							return html`<h4>Results for “${data.query}” (${data.nbHits})</h4>`;
						}
						return html`<h4>Results (0)</h4>`;
					}
				}
			}),
			customNoResults({
				container: document.querySelector('#search-no-results-text'),
				noResultsText: 'No results found. Please try a different query.',
			}),
			menuSelect({
				container: '#site-search-refinements',
				attribute: 'filter_content_type',
				templates: {
					defaultOption(data, { html }) {
						return html`<span>Content Type</span>`;
					},
					item(item, { html }) {
						if(item.label === 'Tertiary'){
							item.label = 'Forms';
						}
						if(item.label === 'Page'){
							item.label = 'Overview Page';
						}
						// - (${item.count.toLocaleString()})
						return html`<span>${item.label}</span>`;
					},
				},
				cssClasses: {
					select: 'content-type form-select',
				}
			}),
			// refinementList({
			// 	container: '#site-search-refinements',
			// 	attribute: 'type',
			// 	operator: 'or',
			// 	limit: 7,
			// 	templates: {
			// 		item(item, { html }) {
			// 		  const { url, label, count, isRefined } = item;

			// 		  return html`
			// 			<a href="${url}" class="mefa-link-button  primary-btn ${isRefined ? 'dark' : 'light'} ">
			// 			  <span>${label} (${count})</span>
			// 			</a>
			// 		  `;
			// 		},
			// 	  },
			// 	// sortBy: ['name:asc'],
			// }),
			infiniteHits({
				container: "#site-search-results",
				cssClasses: {
					list: 'cards-list ',
					loadMore: 'btn btn-primary',
				},
				templates: {
					empty(results, { html }) {
						return html`<div class="no-results">No results found for <q>${results.query}</q><p></p></div>`;
					},
					item(hit, { html, components }) {
						let topic = "";
						let id = hit.objectID;
						if(hit.topic !== null && hit.topic !== undefined){
							hit.topic = hit.topic.filter(topic => topic !== "All Topics" && topic !== "Favorites");
							if(hit.topic.length > 0){
								topic = hit.topic[0];
							}
						}
						id = id.replace('resource#', '');
						let date = hit.date;

						if(hit.image === null){hit.image = "";}
						if(hit.read_time === null){hit.read_time = "";}
						let read_text = "";
						let read_icon = "";
						let read_type = "";
						let webinar_link = "";
						if(hit.type === 'Webinar'){
							read_type = "";
							read_icon = "icon-identification-card";
							webinar_link = hit.event_link || "";
						}
						else if(hit.type === 'Podcast'){
							read_type = "listen";
							read_icon = "icon-microphone";
						}
						else if(hit.type === 'Article' || hit.type === 'Resource' || hit.type === 'Page' || hit.type === 'Tertiary' || hit.type === 'Lesson'){
							read_type = "read";
							read_icon = "icon-book-open-text";
						}
						else if(hit.type === 'Video'){
							read_type = "video";
							read_icon = "icon-video";
						}
						if(hit.filter_content_type !== null && (hit.filter_content_type == "Career Planning" || hit.filter_content_type == "PDF Guide" || hit.filter_content_type == "Calculator" || hit.filter_content_type == "Lesson")){
							read_type = "";
						}
						read_text = `<strong class="text-icon"><span class="${read_icon}"></span></strong>`
						if(hit.read_time !== ""){
							read_text = `<strong class="text-icon"><span class="${read_icon}"></span> ${hit.read_time} ${read_type}</strong>`
						}

						let result = searchTemplate
							.replaceAll("{{id}}", id)
							.replaceAll("{{title}}", hit.title)
							.replaceAll("{{link}}", hit.url)
							.replaceAll("{{image}}", hit.image)
							.replaceAll("{{category}}", topic)//hit.category
							.replaceAll("{{date}}", date)
							.replaceAll("{{read_time}}", read_text)
							;

						return html`${result}`;
					},
				},
			}),
			// pagination({
			// 	container: '#site-search-pagination',
			// 	padding: 2,
			// 	scrollTo: '#site-search-stats',
			// }),
		]);

		search.start();

		search.on('render', () => {
			if (search.helper?.lastResults?.hits.length === 0) {
				document.querySelector('.search-drop__bottom-block').classList.add("no-results-found");
			} else {
				document.querySelector('.search-drop__bottom-block').classList.remove("no-results-found");

				this.normalizeResultsHeight();
			}

		});


		document.querySelectorAll('.search-suggestion').forEach(suggestion => {
			suggestion.addEventListener('click', (e) => {
				e.preventDefault();
				document.querySelector('#site-search-form-holder input').value = e.target.textContent;
				search.helper.setQuery(e.target.textContent).search();
			});
		});

		window.addEventListener('resize', () => {
			this.normalizeResultsHeight();
		});
	}

	normalizeResultsHeight(){
		const hitItems = document.querySelectorAll('#site-search-results .ais-InfiniteHits-item');
		if( !hitItems || hitItems.length === 0 ) return false;

		let maxHeight = 0;
		hitItems.forEach(item => {
			const card = item.querySelector('.card');
			const itemHeight = card.offsetHeight;
			if (itemHeight > maxHeight) {
				maxHeight = itemHeight;
			}
		});

		hitItems.forEach(item => {
			const card = item.querySelector('.card');
			card.style.height = maxHeight + 'px';
		});
	}

}
